import ApiHelpers from './api-helper';

const deleteApiUrl = 'FavouriteApi/RemoveFavourite';
const submitApiUrl = 'FavouriteApi/SubmitFavourite';

export default class ProjectFavourite {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', (e) => {
				// eslint-disable-next-line no-underscore-dangle
				const _el = el;

				e.preventDefault();

				let { isFavourited } = el.dataset;
				if (isFavourited === 'True') {
					ApiHelpers.delete(
						deleteApiUrl,
						{ itemKey: el.dataset?.projectKey },
						ProjectFavourite.toggleFavouriteIcon.bind(null, el),
						null,
						el.dataset?.antiForgeryToken
					);

					isFavourited = 'False';
				} else {
					ApiHelpers.post(
						submitApiUrl,
						{ Key: el.dataset?.projectKey, Tag: el.dataset?.tag, ListType: el.dataset?.listType },
						ProjectFavourite.toggleFavouriteIcon.bind(null, el),
						null
					);

					isFavourited = 'True';
				}

				_el.dataset.isFavourited = isFavourited;
			});
		});
	}

	static toggleFavouriteIcon(el) {
		if (el.parentElement?.classList.contains('icon-favourite--filled')) {
			el.parentElement?.classList.remove('icon-favourite--filled');
			el.parentElement?.classList.add('icon-favourite--outline');
		} else if (el.parentElement?.classList.contains('icon-favourite--outline')) {
			el.parentElement?.classList.remove('icon-favourite--outline');
			el.parentElement?.classList.add('icon-favourite--filled');
		}
		if (el.parentElement?.classList.contains('circle--white')) {
			el.parentElement?.classList.remove('circle--white');
			el.parentElement?.classList.add('circle--dark');
		} else if (el.parentElement?.classList.contains('circle--dark')) {
			el.parentElement?.classList.remove('circle--dark');
			el.parentElement?.classList.add('circle--white');
		}
	}
}
